export const strToRGB = (colorS: string): number[] => {
  colorS = colorS.replace('#', '')
  const len = colorS.length / 3
  const res: number[] = []
  for (let i = 0; i < 3; ++i) {
    res.push(parseInt(colorS.substr(i * len, len), 16))
  }
  return res
}

export const RGBToStr = (color: number[]): string =>
  '#' +
  color
    .map(c => {
      let pad = ''
      const num = c.toString(16)
      for (let i = 0; i < 2 - num.length; ++i) {
        pad += '0'
      }
      return pad + num
    })
    .join('')

export const pickHex = (
  color1: number[],
  color2: number[],
  weight: number
): number[] => {
  if (color1.length !== color2.length) {
    return []
  }
  const rgb: number[] = []
  for (let i = 0; i < color1.length; ++i) {
    rgb.push(Math.round(color1[i] + weight * (color2[i] - color1[i])))
  }
  return rgb
}

export const getColorInGradient = (pos: number, start: string, end: string) =>
  RGBToStr(pickHex(strToRGB(start), strToRGB(end), pos / 100))

export default { strToRGB, RGBToStr, pickHex, getColorInGradient }



// WEBPACK FOOTER //
// ./src/services/colors.ts